import type { ChatProps } from "./ChatProps.types";

export const EMPTY_EDITOR_BLOCKS = {
  content: [
    {
      content: [],
      type: "paragraph",
    },
  ],
  type: "doc",
};

export const DEFAULT_CHAT_PROPS: ChatProps = {
  chatParticipantsCount: 0,
  disableGroupMentions: false,
  isChatAdminOrModerator: false,
  isDirectMessaging: false,
  isThread: false,
  unfurlUrls: {},
};
